import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type RoleTarget, type RoleSource} from 'web-app/util/graphql/api-types';
import type * as PermissionRoleFormTypes from 'web-app/react/manage-employees/roles/permission-role-form/types';

import {type Permission} from './types';
import {type GetRolesAndPermissionsQuery} from './__generated__/queries.api-types';

const domain = 'ADVANCED_PERMISSIONS';

export const {action: setInitialState} = createAction(
    `${domain}/SET_INITIAL_STATE`,
    (permissions: Permission[], roles: GetRolesAndPermissionsQuery['roles']['list']['roles']) => ({permissions, roles}),
);

export const {action: updateRolePermissions} = createAction(
    `${domain}/UPDATE_ROLE_PERMISSIONS`,
    (roles: GetRolesAndPermissionsQuery['roles']['list']['roles']) => ({roles}),
);

export const {action: togglePermission} = createAction(
    `${domain}/TOGGLE_PERMISSION`,
    (roleId: string, permissionId: string) => ({roleId, permissionId}),
);

export const {
    action: fetchData,
    success: fetchDataSuccess,
    failed: fetchDataFailed,
} = createAction(
    `${domain}/FETCH_DATA`,
    (
        institutionSetId: string,
        source: RoleSource,
        target: RoleTarget,
        roleIds?: List<string>,
        mode?: PermissionRoleFormTypes.PermissionRoleFormMode,
    ) => ({institutionSetId, source, target, roleIds, mode}),
    (permissions: Permission[], roles: GetRolesAndPermissionsQuery['roles']['list']['roles']) => ({permissions, roles}),
);

export const {action: addToComparison} = createAction(`${domain}/ADD_TO_COMPARISON`, (roleId: string) => ({roleId}));

export const {action: removeFromComparison} = createAction(`${domain}/REMOVE_FROM_COMPARISON`, (roleId: string) => ({
    roleId,
}));

export const {action: addOneAndRemoveOneFromComparison} = createAction(
    `${domain}/ADD_ONE_AND_REMOVE_ONE_FROM_COMPARISON`,
    (roleId: string) => ({roleId}),
);

export const {action: setComparedRoleIds} = createAction(`${domain}/SET_COMPARED_ROLES`, (roleIds: List<string>) => ({
    roleIds,
}));

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));
